'use client';

import { useState, FormEvent } from 'react';
import { useRouter, useSearchParams } from 'next/navigation';

export default function LoginClient() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const router = useRouter();
  const searchParams = useSearchParams();
  const rawNext = searchParams.get('next') ?? '/dashboard';
  const next = rawNext.startsWith('/') && !rawNext.startsWith('//') ? rawNext : '/dashboard';

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setLoading(true);
    setError('');

    // Read the DOM values: browser autofill fills the fields without firing onChange.
    const form = new FormData(e.currentTarget as HTMLFormElement);
    const res = await fetch('/api/auth/login', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: String(form.get('email') ?? ''), password: String(form.get('password') ?? '') }),
    });

    setLoading(false);
    if (res.ok) {
      router.push(next);
      router.refresh();
    } else {
      setError('E-Mail oder Passwort falsch');
      setPassword('');
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center">
      <form
        onSubmit={handleSubmit}
        className="flex flex-col gap-4 w-full max-w-sm px-6"
      >
        <div className="text-center mb-2">
          <span className="font-bold text-white text-xl">
            kaju<span style={{ color: '#f1c953' }}>SPIELBAUSTEINE</span>
          </span>
          <p className="text-sm text-white/50 mt-1">Dashboard</p>
        </div>

        <input
          type="email"
          name="email"
          autoComplete="username"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="E-Mail"
          autoFocus
          required
          className="px-4 py-2.5 rounded bg-[rgba(var(--on-surface),0.1)] text-white placeholder-white/30 border border-[rgba(var(--on-surface),0.1)] focus:outline-none focus:border-[rgba(var(--on-surface),0.3)]"
        />

        <input
          type="password"
          name="password"
          autoComplete="current-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Passwort"
          required
          className="px-4 py-2.5 rounded bg-[rgba(var(--on-surface),0.1)] text-white placeholder-white/30 border border-[rgba(var(--on-surface),0.1)] focus:outline-none focus:border-[rgba(var(--on-surface),0.3)]"
        />

        {error && (
          <p className="text-sm text-red-400 text-center">{error}</p>
        )}

        <button
          type="submit"
          disabled={loading}
          className="py-2.5 rounded font-semibold transition-opacity disabled:opacity-40"
          style={{ background: '#532c29', color: '#f1c953' }}
        >
          {loading ? 'Wird geprüft…' : 'Einloggen'}
        </button>

        <a href="/passwort-vergessen" className="text-sm text-white/50 text-center hover:text-white/80">
          Passwort vergessen?
        </a>
      </form>
    </div>
  );
}
